module.exports = __webpack_public_path__ + "static/media/next-video.509cb7ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Features/TelestrationsVideoLibrary/Assets/Player/next-video.svg
// module id = 7417
// module chunks = 0